import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
  selector: "admin-panel-ocr",
  templateUrl: "./ocr.component.html",
  styleUrls: ["./ocr.component.css"]
})
export class OcrComponent {

  @Input() title: string = "";

  @Output() selected = new EventEmitter<File>();

  onSelect(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (file) {
      this.selected.emit(file);
      console.log("Selected file:", file.name);
    }
    // optional: reset so selecting the same file twice still triggers change
    input.value = "";
  }

}
